import en from './strings.en';

const ru = {
    successDirectPayment: 'Оплата прошла успешно. Доступ открыт.',
    failDirectPayment: 'Оплата не прошла. Попробуйте оплатить повторно. Если ошибка повторяется —',
    failDirectPaymentLink: 'обратитесь в техподдержку.'
};

export default { ru, en: { ...ru, ...en} };
